import React from "react";
// --- Import components
// import LicenseList from "./LicenseList/LicenseList";
import ErrorBoundary from "../../components/ErrorBoundary/ErrorBoundary";
import LicenseSlider from "./LicenseSlider/LicenseSlider";

import style from "./MyApps.module.sass";

function MyApps() {
  return (
    <div>
      <article className={style.myApps}>
        <section className={`section-title ${style.title}`}>
          <h3>My apps</h3>
        </section>
        <ErrorBoundary
          classWrapper="payment-section__error"
          classText="payment-section__error-text"
        >
          {/* <LicenseList /> */}
          <LicenseSlider />
        </ErrorBoundary>
      </article>
    </div>
  );
}

export default MyApps;
